export default "__VITE_ASSET__b0cbbe0c__"